import { Routes } from "../router/routes";

/**
 * Object with role as key and value, which is used for
 * comparison of role in different place.
 */
export const UserRoles = {
  role: "role",
};

/**
 * Object which has the proper name of all the role
 * used in the application.
 */
export let UserRolesName = {
  role: "Role",
};

/**
 * Object which has the different themes used in
 * the application.
 */
export let Themes = {
  default: "default",
  dark: "dark",
  clmmdark: "clmmdark",
  clmmdarkgreen: "clmmdarkgreen",
  clmmdefaultgreen: "clmmdefaultgreen",
  clmmdefault: "clmmdefault",
  clmmdefaultPurple: "clmmdefaultPurple",
  clmmdarkPurple: "clmmdarkPurple",
};

/**
 * Object which has the different props for the Alert Component (/src/component/alert)
 * which is used via AlertContext (/src/contexts) and provided at /src/App.alert.js.
 */
export let AlertProps = {
  vertical: {
    top: "top",
    bottom: "bottom",
  },
  horizontal: {
    left: "left",
    right: "right",
    center: "center",
  },
  severity: {
    success: "success",
    error: "error",
    warning: "warning",
    info: "info",
  },
};

export let sidebarlist = [
  {
    name: "Printer Configuration",
    id: 1,
    path: Routes.home,
  },
  {
    name: "Printer Queue Configuration",
    id: 2,
    path: Routes.printerQueue,
  },
  {
    name: "Message Configuration",
    id: 3,
    path: Routes.messageConfig,
  },
];
/**
 * Object which has the different props for the Drawer Component (/src/App.drawer.js)
 * which is used via DrawerContext (/src/contexts) and provided at /src/App.drawer.js.
 */
export const DrawerProps = {
  direction: {
    top: "top",
    bottom: "bottom",
    left: "left",
    right: "right",
  },
  variant: {
    permanent: "permanent",
    persistent: "persistent",
    temporary: "temporary",
  },
};

/**
 * Object has the key and value pair of all the keys which
 * are used to store some values in the local storage.
 */
export let LocalStorageKeys = {
  //   projectName: "",

  authToken: "authtoken",

  version: "version",
};

/**
 * Object has the key and value pair of all the HTTP method
 * used for an network call.
 */
export let NetWorkCallMethods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE",
  update: "UPDATE",
};

export const performData = [
  {
    label: "Set as Queue",
    value: 1,
    aliasName: "queuename",
    labelName: "queuename",
    listName: "queueList",
  },
  {
    label: "Set as Printer",
    value: 1,
    aliasName: "printername",
    labelName: "printername",
    listName: "printerList",
  },
  {
    label: "Set Assignee",
    value: 2,
    aliasName: "userRole",
    children: [
      {
        label: "Set single assignee",
        aliasName: "singleasignee",
        labelName: "email",
        listName: "userRole",
      },

      {
        label: "Set to Group",
        aliasName: "group",
        children: [
          {
            label: "Based on Availablity",
            aliasName: "singleasignee",
            labelName: "name",
            listName: "userGroup",
          },
        ],
      },
    ],
  },
];
